import { useTranslation } from 'next-i18next';
export const useTravelDurationLabel = ({
  minDuration,
  maxDuration,
  short = false
}) => {
  const {
    t
  } = useTranslation();
  if (minDuration === 0 && maxDuration === 0) {
    return t(`searchForm:travelPeriodField.exact`);
  }
  if (!minDuration || !maxDuration) {
    return '';
  }
  if (minDuration === maxDuration) {
    const weeks = Math.floor(maxDuration / 7);
    const days = maxDuration % 7;
    if (weeks && days === 0) {
      return t(`searchForm:travelPeriodField.${short ? 'xWeeksShort' : 'xWeeksLong'}`, {
        count: weeks
      });
    }
    return t(`searchForm:travelPeriodField.${short ? 'xDaysShort' : 'xDaysLong'}`, {
      days: maxDuration + 1,
      count: maxDuration + 1
    });
  }
  return t(`searchForm:travelPeriodField.${short ? 'xDaysShort' : 'xDaysLongForcePlural'}`, {
    days: `${minDuration + 1}-${maxDuration + 1}`
  });
};